import { EditorContent as Xt } from "@tiptap/react";
import F, { useState as M, useCallback as A, useRef as Te, useEffect as q, forwardRef as ot } from "react";
import { Box as lt, Menu as p, createStyles as N, Group as Ee, ActionIcon as he, MantineProvider as Zt, Stack as Re, Text as te, Button as ct, Container as Qt, TextInput as en, Badge as tn } from "@mantine/core";
import nn from "react-dom";
import re from "@tippyjs/react";
import { BlockNoteEditor as rn } from "@blocknote/core";
var ae = { exports: {} }, W = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xe;
function an() {
  if (Xe)
    return W;
  Xe = 1;
  var e = F, n = Symbol.for("react.element"), o = Symbol.for("react.fragment"), l = Object.prototype.hasOwnProperty, d = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(m, h, z) {
    var S, _ = {}, L = null, G = null;
    z !== void 0 && (L = "" + z), h.key !== void 0 && (L = "" + h.key), h.ref !== void 0 && (G = h.ref);
    for (S in h)
      l.call(h, S) && !s.hasOwnProperty(S) && (_[S] = h[S]);
    if (m && m.defaultProps)
      for (S in h = m.defaultProps, h)
        _[S] === void 0 && (_[S] = h[S]);
    return { $$typeof: n, type: m, key: L, ref: G, props: _, _owner: d.current };
  }
  return W.Fragment = o, W.jsx = c, W.jsxs = c, W;
}
var Y = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ze;
function on() {
  return Ze || (Ze = 1, process.env.NODE_ENV !== "production" && function() {
    var e = F, n = Symbol.for("react.element"), o = Symbol.for("react.portal"), l = Symbol.for("react.fragment"), d = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), m = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), z = Symbol.for("react.suspense"), S = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), L = Symbol.for("react.lazy"), G = Symbol.for("react.offscreen"), Se = Symbol.iterator, mt = "@@iterator";
    function bt(t) {
      if (t === null || typeof t != "object")
        return null;
      var r = Se && t[Se] || t[mt];
      return typeof r == "function" ? r : null;
    }
    var P = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(t) {
      {
        for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), u = 1; u < r; u++)
          i[u - 1] = arguments[u];
        pt("error", t, i);
      }
    }
    function pt(t, r, i) {
      {
        var u = P.ReactDebugCurrentFrame, g = u.getStackAddendum();
        g !== "" && (r += "%s", i = i.concat([g]));
        var b = i.map(function(v) {
          return String(v);
        });
        b.unshift("Warning: " + r), Function.prototype.apply.call(console[t], console, b);
      }
    }
    var yt = !1, xt = !1, kt = !1, Ct = !1, Tt = !1, we;
    we = Symbol.for("react.module.reference");
    function Et(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === l || t === s || Tt || t === d || t === z || t === S || Ct || t === G || yt || xt || kt || typeof t == "object" && t !== null && (t.$$typeof === L || t.$$typeof === _ || t.$$typeof === c || t.$$typeof === m || t.$$typeof === h || t.$$typeof === we || t.getModuleId !== void 0));
    }
    function Rt(t, r, i) {
      var u = t.displayName;
      if (u)
        return u;
      var g = r.displayName || r.name || "";
      return g !== "" ? i + "(" + g + ")" : i;
    }
    function Me(t) {
      return t.displayName || "Context";
    }
    function I(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case l:
          return "Fragment";
        case o:
          return "Portal";
        case s:
          return "Profiler";
        case d:
          return "StrictMode";
        case z:
          return "Suspense";
        case S:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case m:
            var r = t;
            return Me(r) + ".Consumer";
          case c:
            var i = t;
            return Me(i._context) + ".Provider";
          case h:
            return Rt(t, t.render, "ForwardRef");
          case _:
            var u = t.displayName || null;
            return u !== null ? u : I(t.type) || "Memo";
          case L: {
            var g = t, b = g._payload, v = g._init;
            try {
              return I(v(b));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var D = Object.assign, U = 0, He, ze, _e, Ie, Oe, Fe, Be;
    function Le() {
    }
    Le.__reactDisabledLog = !0;
    function St() {
      {
        if (U === 0) {
          He = console.log, ze = console.info, _e = console.warn, Ie = console.error, Oe = console.group, Fe = console.groupCollapsed, Be = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Le,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        U++;
      }
    }
    function wt() {
      {
        if (U--, U === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: D({}, t, {
              value: He
            }),
            info: D({}, t, {
              value: ze
            }),
            warn: D({}, t, {
              value: _e
            }),
            error: D({}, t, {
              value: Ie
            }),
            group: D({}, t, {
              value: Oe
            }),
            groupCollapsed: D({}, t, {
              value: Fe
            }),
            groupEnd: D({}, t, {
              value: Be
            })
          });
        }
        U < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var oe = P.ReactCurrentDispatcher, le;
    function K(t, r, i) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch (g) {
            var u = g.stack.trim().match(/\n( *(at )?)/);
            le = u && u[1] || "";
          }
        return `
` + le + t;
      }
    }
    var ce = !1, J;
    {
      var Mt = typeof WeakMap == "function" ? WeakMap : Map;
      J = new Mt();
    }
    function De(t, r) {
      if (!t || ce)
        return "";
      {
        var i = J.get(t);
        if (i !== void 0)
          return i;
      }
      var u;
      ce = !0;
      var g = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var b;
      b = oe.current, oe.current = null, St();
      try {
        if (r) {
          var v = function() {
            throw Error();
          };
          if (Object.defineProperty(v.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(v, []);
            } catch (O) {
              u = O;
            }
            Reflect.construct(t, [], v);
          } else {
            try {
              v.call();
            } catch (O) {
              u = O;
            }
            t.call(v.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (O) {
            u = O;
          }
          t();
        }
      } catch (O) {
        if (O && u && typeof O.stack == "string") {
          for (var f = O.stack.split(`
`), T = u.stack.split(`
`), x = f.length - 1, k = T.length - 1; x >= 1 && k >= 0 && f[x] !== T[k]; )
            k--;
          for (; x >= 1 && k >= 0; x--, k--)
            if (f[x] !== T[k]) {
              if (x !== 1 || k !== 1)
                do
                  if (x--, k--, k < 0 || f[x] !== T[k]) {
                    var H = `
` + f[x].replace(" at new ", " at ");
                    return t.displayName && H.includes("<anonymous>") && (H = H.replace("<anonymous>", t.displayName)), typeof t == "function" && J.set(t, H), H;
                  }
                while (x >= 1 && k >= 0);
              break;
            }
        }
      } finally {
        ce = !1, oe.current = b, wt(), Error.prepareStackTrace = g;
      }
      var j = t ? t.displayName || t.name : "", Je = j ? K(j) : "";
      return typeof t == "function" && J.set(t, Je), Je;
    }
    function Ht(t, r, i) {
      return De(t, !1);
    }
    function zt(t) {
      var r = t.prototype;
      return !!(r && r.isReactComponent);
    }
    function X(t, r, i) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return De(t, zt(t));
      if (typeof t == "string")
        return K(t);
      switch (t) {
        case z:
          return K("Suspense");
        case S:
          return K("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case h:
            return Ht(t.render);
          case _:
            return X(t.type, r, i);
          case L: {
            var u = t, g = u._payload, b = u._init;
            try {
              return X(b(g), r, i);
            } catch {
            }
          }
        }
      return "";
    }
    var Z = Object.prototype.hasOwnProperty, Ae = {}, Pe = P.ReactDebugCurrentFrame;
    function Q(t) {
      if (t) {
        var r = t._owner, i = X(t.type, t._source, r ? r.type : null);
        Pe.setExtraStackFrame(i);
      } else
        Pe.setExtraStackFrame(null);
    }
    function _t(t, r, i, u, g) {
      {
        var b = Function.call.bind(Z);
        for (var v in t)
          if (b(t, v)) {
            var f = void 0;
            try {
              if (typeof t[v] != "function") {
                var T = Error((u || "React class") + ": " + i + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw T.name = "Invariant Violation", T;
              }
              f = t[v](r, v, u, i, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              f = x;
            }
            f && !(f instanceof Error) && (Q(g), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", u || "React class", i, v, typeof f), Q(null)), f instanceof Error && !(f.message in Ae) && (Ae[f.message] = !0, Q(g), C("Failed %s type: %s", i, f.message), Q(null));
          }
      }
    }
    var It = Array.isArray;
    function de(t) {
      return It(t);
    }
    function Ot(t) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, i = r && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return i;
      }
    }
    function Ft(t) {
      try {
        return Ve(t), !1;
      } catch {
        return !0;
      }
    }
    function Ve(t) {
      return "" + t;
    }
    function je(t) {
      if (Ft(t))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ot(t)), Ve(t);
    }
    var $ = P.ReactCurrentOwner, Bt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Ue, se;
    se = {};
    function Lt(t) {
      if (Z.call(t, "ref")) {
        var r = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function Dt(t) {
      if (Z.call(t, "key")) {
        var r = Object.getOwnPropertyDescriptor(t, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function At(t, r) {
      if (typeof t.ref == "string" && $.current && r && $.current.stateNode !== r) {
        var i = I($.current.type);
        se[i] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', I($.current.type), t.ref), se[i] = !0);
      }
    }
    function Pt(t, r) {
      {
        var i = function() {
          Ne || (Ne = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        i.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: i,
          configurable: !0
        });
      }
    }
    function Vt(t, r) {
      {
        var i = function() {
          Ue || (Ue = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        i.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: i,
          configurable: !0
        });
      }
    }
    var jt = function(t, r, i, u, g, b, v) {
      var f = {
        $$typeof: n,
        type: t,
        key: r,
        ref: i,
        props: v,
        _owner: b
      };
      return f._store = {}, Object.defineProperty(f._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(f, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: u
      }), Object.defineProperty(f, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.freeze && (Object.freeze(f.props), Object.freeze(f)), f;
    };
    function Nt(t, r, i, u, g) {
      {
        var b, v = {}, f = null, T = null;
        i !== void 0 && (je(i), f = "" + i), Dt(r) && (je(r.key), f = "" + r.key), Lt(r) && (T = r.ref, At(r, g));
        for (b in r)
          Z.call(r, b) && !Bt.hasOwnProperty(b) && (v[b] = r[b]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (b in x)
            v[b] === void 0 && (v[b] = x[b]);
        }
        if (f || T) {
          var k = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          f && Pt(v, k), T && Vt(v, k);
        }
        return jt(t, f, T, g, u, $.current, v);
      }
    }
    var ue = P.ReactCurrentOwner, $e = P.ReactDebugCurrentFrame;
    function V(t) {
      if (t) {
        var r = t._owner, i = X(t.type, t._source, r ? r.type : null);
        $e.setExtraStackFrame(i);
      } else
        $e.setExtraStackFrame(null);
    }
    var fe;
    fe = !1;
    function ve(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function We() {
      {
        if (ue.current) {
          var t = I(ue.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Ut(t) {
      {
        if (t !== void 0) {
          var r = t.fileName.replace(/^.*[\\\/]/, ""), i = t.lineNumber;
          return `

Check your code at ` + r + ":" + i + ".";
        }
        return "";
      }
    }
    var Ye = {};
    function $t(t) {
      {
        var r = We();
        if (!r) {
          var i = typeof t == "string" ? t : t.displayName || t.name;
          i && (r = `

Check the top-level render call using <` + i + ">.");
        }
        return r;
      }
    }
    function qe(t, r) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var i = $t(r);
        if (Ye[i])
          return;
        Ye[i] = !0;
        var u = "";
        t && t._owner && t._owner !== ue.current && (u = " It was passed a child from " + I(t._owner.type) + "."), V(t), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', i, u), V(null);
      }
    }
    function Ge(t, r) {
      {
        if (typeof t != "object")
          return;
        if (de(t))
          for (var i = 0; i < t.length; i++) {
            var u = t[i];
            ve(u) && qe(u, r);
          }
        else if (ve(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var g = bt(t);
          if (typeof g == "function" && g !== t.entries)
            for (var b = g.call(t), v; !(v = b.next()).done; )
              ve(v.value) && qe(v.value, r);
        }
      }
    }
    function Wt(t) {
      {
        var r = t.type;
        if (r == null || typeof r == "string")
          return;
        var i;
        if (typeof r == "function")
          i = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === h || r.$$typeof === _))
          i = r.propTypes;
        else
          return;
        if (i) {
          var u = I(r);
          _t(i, t.props, "prop", u, t);
        } else if (r.PropTypes !== void 0 && !fe) {
          fe = !0;
          var g = I(r);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", g || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Yt(t) {
      {
        for (var r = Object.keys(t.props), i = 0; i < r.length; i++) {
          var u = r[i];
          if (u !== "children" && u !== "key") {
            V(t), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", u), V(null);
            break;
          }
        }
        t.ref !== null && (V(t), C("Invalid attribute `ref` supplied to `React.Fragment`."), V(null));
      }
    }
    function Ke(t, r, i, u, g, b) {
      {
        var v = Et(t);
        if (!v) {
          var f = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (f += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var T = Ut(g);
          T ? f += T : f += We();
          var x;
          t === null ? x = "null" : de(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (I(t.type) || "Unknown") + " />", f = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, f);
        }
        var k = Nt(t, r, i, g, b);
        if (k == null)
          return k;
        if (v) {
          var H = r.children;
          if (H !== void 0)
            if (u)
              if (de(H)) {
                for (var j = 0; j < H.length; j++)
                  Ge(H[j], t);
                Object.freeze && Object.freeze(H);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ge(H, t);
        }
        return t === l ? Yt(k) : Wt(k), k;
      }
    }
    function qt(t, r, i) {
      return Ke(t, r, i, !0);
    }
    function Gt(t, r, i) {
      return Ke(t, r, i, !1);
    }
    var Kt = Gt, Jt = qt;
    Y.Fragment = l, Y.jsx = Kt, Y.jsxs = Jt;
  }()), Y;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = an() : e.exports = on();
})(ae);
const a = ae.exports.jsx, R = ae.exports.jsxs, ln = ae.exports.Fragment;
function Xn(e) {
  var n;
  return /* @__PURE__ */ a(Xt, {
    editor: ((n = e.editor) == null ? void 0 : n.tiptapEditor) || null
  });
}
var dt = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Qe = F.createContext && F.createContext(dt), B = globalThis && globalThis.__assign || function() {
  return B = Object.assign || function(e) {
    for (var n, o = 1, l = arguments.length; o < l; o++) {
      n = arguments[o];
      for (var d in n)
        Object.prototype.hasOwnProperty.call(n, d) && (e[d] = n[d]);
    }
    return e;
  }, B.apply(this, arguments);
}, cn = globalThis && globalThis.__rest || function(e, n) {
  var o = {};
  for (var l in e)
    Object.prototype.hasOwnProperty.call(e, l) && n.indexOf(l) < 0 && (o[l] = e[l]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var d = 0, l = Object.getOwnPropertySymbols(e); d < l.length; d++)
      n.indexOf(l[d]) < 0 && Object.prototype.propertyIsEnumerable.call(e, l[d]) && (o[l[d]] = e[l[d]]);
  return o;
};
function st(e) {
  return e && e.map(function(n, o) {
    return F.createElement(n.tag, B({
      key: o
    }, n.attr), st(n.child));
  });
}
function y(e) {
  return function(n) {
    return F.createElement(dn, B({
      attr: B({}, e.attr)
    }, n), st(e.child));
  };
}
function dn(e) {
  var n = function(o) {
    var l = e.attr, d = e.size, s = e.title, c = cn(e, ["attr", "size", "title"]), m = d || o.size || "1em", h;
    return o.className && (h = o.className), e.className && (h = (h ? h + " " : "") + e.className), F.createElement("svg", B({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, o.attr, l, c, {
      className: h,
      style: B(B({
        color: e.color || o.color
      }, o.style), e.style),
      height: m,
      width: m,
      xmlns: "http://www.w3.org/2000/svg"
    }), s && F.createElement("title", null, s), e.children);
  };
  return Qe !== void 0 ? F.createElement(Qe.Consumer, null, function(o) {
    return n(o);
  }) : n(dt);
}
function sn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" } }] })(e);
}
function ge(e) {
  return y({ tag: "svg", attr: { version: "1.2", baseProfile: "tiny", viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M16.972 6.251c-.967-.538-2.185-.188-2.72.777l-3.713 6.682-2.125-2.125c-.781-.781-2.047-.781-2.828 0-.781.781-.781 2.047 0 2.828l4 4c.378.379.888.587 1.414.587l.277-.02c.621-.087 1.166-.46 1.471-1.009l5-9c.537-.966.189-2.183-.776-2.72z" } }] })(e);
}
function un(e) {
  return y({ tag: "svg", attr: { t: "1551322312294", style: "", viewBox: "0 0 1024 1024", version: "1.1" }, child: [{ tag: "defs", attr: {}, child: [] }, { tag: "path", attr: { d: "M474 152m8 0l60 0q8 0 8 8l0 704q0 8-8 8l-60 0q-8 0-8-8l0-704q0-8 8-8Z" } }, { tag: "path", attr: { d: "M168 474m8 0l672 0q8 0 8 8l0 60q0 8-8 8l-672 0q-8 0-8-8l0-60q0-8 8-8Z" } }] })(e);
}
function fn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M3 4h18v2H3V4zm2 15h14v2H5v-2zm-2-5h18v2H3v-2zm2-5h14v2H5V9z" } }] }] })(e);
}
function vn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M3 4h18v2H3V4zm0 15h14v2H3v-2zm0-5h18v2H3v-2zm0-5h14v2H3V9z" } }] }] })(e);
}
function hn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M3 4h18v2H3V4zm4 15h14v2H7v-2zm-4-5h18v2H3v-2zm4-5h14v2H7V9z" } }] }] })(e);
}
function gn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M8 11h4.5a2.5 2.5 0 1 0 0-5H8v5zm10 4.5a4.5 4.5 0 0 1-4.5 4.5H6V4h6.5a4.5 4.5 0 0 1 3.256 7.606A4.498 4.498 0 0 1 18 15.5zM8 13v5h5.5a2.5 2.5 0 1 0 0-5H8z" } }] }] })(e);
}
function me(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0H24V24H0z" } }, { tag: "path", attr: { d: "M13 20h-2v-7H4v7H2V4h2v7h7V4h2v16zm8-12v12h-2v-9.796l-2 .536V8.67L19.5 8H21z" } }] }] })(e);
}
function be(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0H24V24H0z" } }, { tag: "path", attr: { d: "M4 4v7h7V4h2v16h-2v-7H4v7H2V4h2zm14.5 4c2.071 0 3.75 1.679 3.75 3.75 0 .857-.288 1.648-.772 2.28l-.148.18L18.034 18H22v2h-7v-1.556l4.82-5.546c.268-.307.43-.709.43-1.148 0-.966-.784-1.75-1.75-1.75-.918 0-1.671.707-1.744 1.606l-.006.144h-2C14.75 9.679 16.429 8 18.5 8z" } }] }] })(e);
}
function pe(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0H24V24H0z" } }, { tag: "path", attr: { d: "M22 8l-.002 2-2.505 2.883c1.59.435 2.757 1.89 2.757 3.617 0 2.071-1.679 3.75-3.75 3.75-1.826 0-3.347-1.305-3.682-3.033l1.964-.382c.156.806.866 1.415 1.718 1.415.966 0 1.75-.784 1.75-1.75s-.784-1.75-1.75-1.75c-.286 0-.556.069-.794.19l-1.307-1.547L19.35 10H15V8h7zM4 4v7h7V4h2v16h-2v-7H4v7H2V4h2z" } }] }] })(e);
}
function mn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M3 4h18v2H3V4zm0 15h18v2H3v-2zm8-5h10v2H11v-2zm0-5h10v2H11V9zm-8 3.5L7 9v7l-4-3.5z" } }] }] })(e);
}
function bn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M3 4h18v2H3V4zm0 15h18v2H3v-2zm8-5h10v2H11v-2zm0-5h10v2H11V9zm-4 3.5L3 16V9l4 3.5z" } }] }] })(e);
}
function pn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15z" } }] }] })(e);
}
function yn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M17 17h5v2h-3v3h-2v-5zM7 7H2V5h3V2h2v5zm11.364 8.536L16.95 14.12l1.414-1.414a5 5 0 1 0-7.071-7.071L9.879 7.05 8.464 5.636 9.88 4.222a7 7 0 0 1 9.9 9.9l-1.415 1.414zm-2.828 2.828l-1.415 1.414a7 7 0 0 1-9.9-9.9l1.415-1.414L7.05 9.88l-1.414 1.414a5 5 0 1 0 7.071 7.071l1.414-1.414 1.415 1.414zm-.708-10.607l1.415 1.415-7.071 7.07-1.415-1.414 7.071-7.07z" } }] }] })(e);
}
function ut(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M18.364 15.536L16.95 14.12l1.414-1.414a5 5 0 1 0-7.071-7.071L9.879 7.05 8.464 5.636 9.88 4.222a7 7 0 0 1 9.9 9.9l-1.415 1.414zm-2.828 2.828l-1.415 1.414a7 7 0 0 1-9.9-9.9l1.415-1.414L7.05 9.88l-1.414 1.414a5 5 0 1 0 7.071 7.071l1.414-1.414 1.415 1.414zm-.708-10.607l1.415 1.415-7.071 7.07-1.415-1.414 7.071-7.07z" } }] }] })(e);
}
function ye(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M8 4h13v2H8V4zM5 3v3h1v1H3V6h1V4H3V3h2zM3 14v-2.5h2V11H3v-1h3v2.5H4v.5h2v1H3zm2 5.5H3v-1h2V18H3v-1h3v4H3v-1h2v-.5zM8 11h13v2H8v-2zm0 7h13v2H8v-2z" } }] }] })(e);
}
function xe(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M8 4h13v2H8V4zM4.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 6.9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM8 11h13v2H8v-2zm0 7h13v2H8v-2z" } }] }] })(e);
}
function xn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M17.154 14c.23.516.346 1.09.346 1.72 0 1.342-.524 2.392-1.571 3.147C14.88 19.622 13.433 20 11.586 20c-1.64 0-3.263-.381-4.87-1.144V16.6c1.52.877 3.075 1.316 4.666 1.316 2.551 0 3.83-.732 3.839-2.197a2.21 2.21 0 0 0-.648-1.603l-.12-.117H3v-2h18v2h-3.846zm-4.078-3H7.629a4.086 4.086 0 0 1-.481-.522C6.716 9.92 6.5 9.246 6.5 8.452c0-1.236.466-2.287 1.397-3.153C8.83 4.433 10.271 4 12.222 4c1.471 0 2.879.328 4.222.984v2.152c-1.2-.687-2.515-1.03-3.946-1.03-2.48 0-3.719.782-3.719 2.346 0 .42.218.786.654 1.099.436.313.974.562 1.613.75.62.18 1.297.414 2.03.699z" } }] }] })(e);
}
function ne(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M13 6v15h-2V6H5V4h14v2z" } }] }] })(e);
}
function kn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M8 3v9a4 4 0 1 0 8 0V3h2v9a6 6 0 1 1-12 0V3h2zM4 20h16v2H4v-2z" } }] }] })(e);
}
function Cn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "g", attr: {}, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm11-3v9l-3.794-3.793-5.999 6-1.414-1.414 5.999-6L12 3h9z" } }] }] })(e);
}
function Tn(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 20 20", fill: "currentColor" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z", clipRule: "evenodd" } }] })(e);
}
function En(e) {
  return y({ tag: "svg", attr: { viewBox: "0 0 20 20", fill: "currentColor" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z", clipRule: "evenodd" } }] })(e);
}
const ke = (e) => {
  const n = e.textColor || "default", o = e.backgroundColor || "default", l = e.size || 16;
  return /* @__PURE__ */ a(lt, {
    sx: (d) => ({
      backgroundColor: d.colors.backgroundColors[d.other.colors.indexOf(o)],
      border: "solid #D3D3D3 1px",
      borderRadius: (l * 0.25).toString() + "px",
      color: d.colors.textColors[d.other.colors.indexOf(n)],
      fontSize: (l * 0.75).toString() + "px",
      height: l.toString() + "px",
      lineHeight: l.toString() + "px",
      textAlign: "center",
      width: l.toString() + "px"
    }),
    children: "A"
  });
}, ft = (e) => /* @__PURE__ */ R(ln, {
  children: [/* @__PURE__ */ a(p.Label, {
    children: "Text"
  }), ["default", "grey", "brown", "red", "orange", "yellow", "green", "blue", "purple", "pink"].map((n) => /* @__PURE__ */ a(p.Item, {
    onClick: () => {
      e.onClick && e.onClick(), e.setTextColor(n);
    },
    component: "div",
    "data-test": "text-color-" + n,
    icon: /* @__PURE__ */ a(ke, {
      textColor: n,
      size: e.iconSize
    }),
    rightSection: e.textColor === n ? /* @__PURE__ */ a(ge, {
      size: 16,
      style: {
        paddingLeft: "8px"
      }
    }) : /* @__PURE__ */ a("div", {
      style: {
        width: "24px",
        padding: "0"
      }
    }),
    children: n.charAt(0).toUpperCase() + n.slice(1)
  }, "text-color-" + n)), /* @__PURE__ */ a(p.Label, {
    children: "Background"
  }), ["default", "grey", "brown", "red", "orange", "yellow", "green", "blue", "purple", "pink"].map((n) => /* @__PURE__ */ a(p.Item, {
    onClick: () => {
      e.onClick && e.onClick(), e.setBackgroundColor(n);
    },
    component: "div",
    "data-test": "background-color-" + n,
    icon: /* @__PURE__ */ a(ke, {
      backgroundColor: n,
      size: e.iconSize
    }),
    rightSection: e.backgroundColor === n ? /* @__PURE__ */ a(ge, {
      size: 16,
      style: {
        paddingLeft: "8px"
      }
    }) : /* @__PURE__ */ a("div", {
      style: {
        width: "24px",
        padding: "0"
      }
    }),
    children: n.charAt(0).toUpperCase() + n.slice(1)
  }, "background-color-" + n))]
}), Rn = (e) => {
  const [n, o] = M(!1), [l, d] = M(void 0), [s, c] = M(void 0), m = A(() => {
    d(setTimeout(() => {
      o(!1);
    }, 250));
  }, []), h = A(() => {
    l && (clearTimeout(l), d(void 0)), o(!0);
  }, [l]);
  return /* @__PURE__ */ R(p, {
    opened: n,
    children: [/* @__PURE__ */ a(p.Item, {
      style: {
        backgroundColor: s
      },
      component: "div",
      onMouseLeave: () => {
        m(), c(void 0);
      },
      onMouseOver: () => {
        h(), c("#f1f3f5");
      },
      rightSection: /* @__PURE__ */ a(lt, {
        style: {
          display: "flex",
          alignItems: "center"
        },
        children: /* @__PURE__ */ a(En, {
          size: 15
        })
      }),
      children: "Colors"
    }), /* @__PURE__ */ a(p.Dropdown, {
      onMouseLeave: () => {
        m(), c(void 0);
      },
      onMouseOver: () => {
        h(), c("#f1f3f5");
      },
      style: {
        marginLeft: "90px"
      },
      children: /* @__PURE__ */ a(ft, {
        onClick: e.onClick,
        iconSize: 18,
        textColor: e.blockTextColor,
        setTextColor: e.setBlockTextColor,
        backgroundColor: e.blockBackgroundColor,
        setBackgroundColor: e.setBlockBackgroundColor
      })
    })]
  });
}, Sn = (e) => {
  const {
    classes: n
  } = N({
    root: {}
  })(void 0, {
    name: "DragHandleMenu"
  }), [o, l] = M(!1), d = Te(null);
  return q(() => {
    const s = d.current;
    if (s instanceof HTMLDivElement)
      return s.addEventListener("dragstart", e.blockDragStart), s.addEventListener("dragend", e.blockDragEnd), () => {
        s.removeEventListener("dragstart", e.blockDragStart), s.removeEventListener("dragend", e.blockDragEnd);
      };
  }, [e.blockDragEnd, e.blockDragStart]), /* @__PURE__ */ R(Ee, {
    spacing: 0,
    children: [/* @__PURE__ */ a(he, {
      size: 24,
      color: "brandFinal.3",
      "data-test": "dragHandleAdd",
      children: /* @__PURE__ */ a(un, {
        size: 24,
        onClick: () => {
          e.addBlock();
        }
      })
    }), /* @__PURE__ */ R(p, {
      opened: o,
      width: 100,
      position: "left",
      children: [/* @__PURE__ */ a(p.Target, {
        children: /* @__PURE__ */ a("div", {
          draggable: "true",
          ref: d,
          children: /* @__PURE__ */ a(he, {
            onClick: () => {
              l(!0), e.freezeMenu();
            },
            size: 24,
            color: "brandFinal.3",
            "data-test": "dragHandle",
            children: /* @__PURE__ */ a(sn, {
              size: 24
            })
          })
        })
      }), /* @__PURE__ */ R(p.Dropdown, {
        className: n.root,
        children: [/* @__PURE__ */ a(p.Item, {
          component: "div",
          onClick: () => {
            l(!1), e.unfreezeMenu(), e.deleteBlock();
          },
          children: "Delete"
        }), /* @__PURE__ */ a(Rn, {
          onClick: () => {
            l(!1), e.unfreezeMenu();
          },
          ...e
        })]
      })]
    })]
  });
};
var Ce, ee = nn;
if (process.env.NODE_ENV === "production")
  Ce = ee.createRoot, ee.hydrateRoot;
else {
  var et = ee.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  Ce = function(e, n) {
    et.usingClientEntryPoint = !0;
    try {
      return ee.createRoot(e, n);
    } finally {
      et.usingClientEntryPoint = !1;
    }
  };
}
const wn = {
  activeStyles: {
    transform: "none"
  },
  colorScheme: "light",
  colors: {
    brandFinal: [
      "#F6F6F8",
      "#ECEDF0",
      "#DFE1E6",
      "#C2C7D0",
      "#A6ADBA",
      "#8993A4",
      "#6D798F",
      "#505F79",
      "#344563",
      "#172B4D"
    ],
    textColors: [
      "#37352f",
      "#9b9a97",
      "#64473a",
      "#e03e3e",
      "#d9730d",
      "#dfab01",
      "#4d6461",
      "#0b6e99",
      "#6940a5",
      "#ad1a72"
    ],
    backgroundColors: [
      "#ffffff",
      "#ebeced",
      "#e9e5e3",
      "#fbe4e4",
      "#f6e9d9",
      "#fbf3db",
      "#ddedea",
      "#ddebf1",
      "#eae4f2",
      "#f4dfeb"
    ]
  },
  components: {
    Menu: {
      styles: (e) => ({
        dropdown: {
          backgroundColor: "white",
          boxShadow: `0px 4px 8px ${e.colors.brandFinal[2]}, 0px 0px 1px ${e.colors.brandFinal[2]}`,
          border: `1px solid ${e.colors.brandFinal[1]}`,
          borderRadius: "6px",
          padding: "2px"
        }
      })
    },
    DragHandleMenu: {
      styles: (e) => ({
        root: {
          ".mantine-Menu-item": {
            color: e.colors.brandFinal,
            fontSize: "12px",
            height: "30px"
          }
        }
      })
    },
    EditHyperlinkMenu: {
      styles: (e) => ({
        root: {
          backgroundColor: "white",
          boxShadow: `0px 4px 8px ${e.colors.brandFinal[2]}, 0px 0px 1px ${e.colors.brandFinal[2]}`,
          border: `1px solid ${e.colors.brandFinal[1]}`,
          borderRadius: "6px",
          gap: "4px",
          minWidth: "145px",
          padding: "2px",
          ".mantine-Group-root": {
            flexWrap: "nowrap",
            gap: "8px",
            paddingInline: "6px",
            ".mantine-Container-root": {
              color: e.colors.brandFinal,
              display: "flex",
              justifyContent: "center",
              padding: "0",
              width: "fit-content"
            },
            ".mantine-TextInput-root": {
              background: "transparent",
              width: "300px",
              ".mantine-TextInput-wrapper": {
                ".mantine-TextInput-input": {
                  fontSize: "12px",
                  border: 0,
                  padding: 0
                }
              }
            }
          }
        }
      })
    },
    Toolbar: {
      styles: (e) => ({
        root: {
          backgroundColor: "white",
          boxShadow: `0px 4px 8px ${e.colors.brandFinal[2]}, 0px 0px 1px ${e.colors.brandFinal[2]}`,
          border: `1px solid ${e.colors.brandFinal[1]}`,
          borderRadius: "6px",
          flexWrap: "nowrap",
          gap: "2px",
          padding: "2px",
          width: "fit-content",
          ".mantine-UnstyledButton-root": {
            borderRadius: "4px"
          },
          ".mantine-Menu-dropdown": {
            ".mantine-Menu-item": {
              color: e.colors.brandFinal,
              fontSize: "12px",
              height: "30px",
              ".mantine-Menu-itemRightSection": {
                paddingLeft: "5px"
              }
            }
          }
        }
      })
    },
    Tooltip: {
      styles: (e) => ({
        root: {
          color: e.colors.brandFinal[2],
          backgroundColor: e.colors.brandFinal,
          border: `1px solid ${e.colors.brandFinal[1]}`,
          borderRadius: "6px",
          boxShadow: `0px 4px 8px ${e.colors.brandFinal[2]}, 0px 0px 1px ${e.colors.brandFinal[2]}`,
          padding: "4px 10px",
          textAlign: "center",
          "div ~ div": {
            color: e.colors.brandFinal[4]
          }
        }
      })
    },
    SlashMenu: {
      styles: (e) => ({
        root: {
          ".mantine-Menu-item": {
            ".mantine-Menu-itemIcon": {
              padding: "8px",
              border: `1px solid ${e.colors.brandFinal[2]}`,
              backgroundColor: e.colors.brandFinal[0],
              borderRadius: "4px",
              color: e.colors.brandFinal
            },
            ".mantine-Menu-itemLabel": {
              color: e.colors.brandFinal,
              paddingRight: "16px",
              ".mantine-Stack-root": {
                gap: "0"
              }
            },
            ".mantine-Menu-itemRightSection": {
              ".mantine-Badge-root": {
                border: `1px solid ${e.colors.brandFinal[2]}`
              }
            }
          }
        }
      })
    }
  },
  fontFamily: "Inter",
  other: {
    colors: [
      "default",
      "gray",
      "brown",
      "red",
      "orange",
      "yellow",
      "green",
      "blue",
      "purple",
      "pink"
    ]
  },
  primaryColor: "brandFinal",
  primaryShade: 9
};
function tt(e) {
  const n = e.editorElementComponent, [o, l] = M(!1), d = A(() => e.dynamicParams.referenceRect, [e.dynamicParams]), s = A(() => {
    l(!1), document.body.appendChild(e.rootElement);
  }, [e.rootElement]), c = A(() => {
    e.rootElement.remove(), l(!0);
  }, [e.rootElement]);
  return /* @__PURE__ */ a(Zt, {
    theme: wn,
    children: /* @__PURE__ */ a(re, {
      appendTo: e.rootElement,
      content: o ? void 0 : /* @__PURE__ */ a(n, {
        ...e.staticParams,
        ...e.dynamicParams
      }),
      getReferenceClientRect: o ? void 0 : d,
      interactive: !0,
      onShow: s,
      onHidden: c,
      visible: e.isOpen,
      ...e.tippyProps
    })
  });
}
const ie = (e, n, o) => {
  const l = document.createElement("div"), d = Ce(l);
  let s;
  return {
    element: l,
    render: (c, m) => {
      s = c, d.render(/* @__PURE__ */ a(tt, {
        rootElement: l,
        isOpen: !0,
        staticParams: e,
        dynamicParams: c,
        editorElementComponent: n,
        tippyProps: o
      }));
    },
    hide: () => {
      d.render(/* @__PURE__ */ a(tt, {
        rootElement: l,
        isOpen: !1,
        staticParams: e,
        dynamicParams: s,
        editorElementComponent: n,
        tippyProps: o
      }));
    }
  };
}, Mn = (e) => ie(e, Sn, {
  animation: "fade",
  offset: [0, 0],
  placement: "left"
}), vt = (e) => {
  const {
    classes: n
  } = N({
    root: {}
  })(void 0, {
    name: "Toolbar"
  });
  return /* @__PURE__ */ a(Ee, {
    className: n.root,
    children: e.children
  });
}, ht = (e) => {
  const {
    classes: n
  } = N({
    root: {}
  })(void 0, {
    name: "Tooltip"
  });
  return /* @__PURE__ */ R(Re, {
    spacing: 0,
    className: n.root,
    children: [/* @__PURE__ */ a(te, {
      size: "sm",
      children: e.mainTooltip
    }), e.secondaryTooltip && /* @__PURE__ */ a(te, {
      size: "xs",
      children: e.secondaryTooltip
    })]
  });
}, E = ot((e, n) => {
  const o = e.icon;
  return /* @__PURE__ */ a(re, {
    content: /* @__PURE__ */ a(ht, {
      mainTooltip: e.mainTooltip,
      secondaryTooltip: e.secondaryTooltip
    }),
    trigger: "mouseenter",
    children: e.children ? /* @__PURE__ */ R(ct, {
      onClick: e.onClick,
      color: "brandFinal",
      "data-test": e.mainTooltip.slice(0, 1).toLowerCase() + e.mainTooltip.replace(/\s+/g, "").slice(1),
      size: "xs",
      variant: e.isSelected ? "filled" : "subtle",
      disabled: e.isDisabled || !1,
      ref: n,
      children: [o && /* @__PURE__ */ a(o, {}), e.children]
    }) : /* @__PURE__ */ a(he, {
      onClick: e.onClick,
      color: "brandFinal",
      "data-test": e.mainTooltip.slice(0, 1).toLowerCase() + e.mainTooltip.replace(/\s+/g, "").slice(1),
      size: 30,
      variant: e.isSelected ? "filled" : "subtle",
      disabled: e.isDisabled || !1,
      ref: n,
      children: o && /* @__PURE__ */ a(o, {})
    })
  });
}), Hn = ot((e, n) => {
  const {
    text: o,
    icon: l,
    isDisabled: d,
    ...s
  } = e, c = e.icon;
  return /* @__PURE__ */ a(ct, {
    leftIcon: c && /* @__PURE__ */ a(c, {
      size: 16
    }),
    rightIcon: /* @__PURE__ */ a(Tn, {}),
    size: "xs",
    variant: "subtle",
    disabled: e.isDisabled,
    ref: n,
    ...s,
    children: e.text
  });
});
function zn(e) {
  const n = e.icon;
  return /* @__PURE__ */ a(p.Item, {
    onClick: e.onClick,
    icon: n && /* @__PURE__ */ a(n, {
      size: 16
    }),
    rightSection: e.isSelected ? /* @__PURE__ */ a(ge, {
      size: 16
    }) : /* @__PURE__ */ a("div", {
      style: {
        width: "16px",
        padding: "0"
      }
    }),
    disabled: e.isDisabled,
    children: e.text
  }, e.text);
}
function _n(e) {
  return /* @__PURE__ */ R(p, {
    exitTransitionDuration: 0,
    children: [/* @__PURE__ */ a(p.Target, {
      children: /* @__PURE__ */ a(Hn, {
        ...e
      })
    }), /* @__PURE__ */ a(p.Dropdown, {
      children: e.items.map((n) => /* @__PURE__ */ a(zn, {
        ...n
      }, n.text))
    })]
  });
}
const In = () => /Mac/.test(navigator.platform) || /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
function w(e) {
  return In() ? e.replace("Mod", "\u2318") : e.replace("Mod", "Ctrl");
}
function On(e) {
  const n = e.icon;
  return /* @__PURE__ */ a(re, {
    content: /* @__PURE__ */ a(ht, {
      mainTooltip: e.mainTooltip,
      secondaryTooltip: e.secondaryTooltip
    }),
    placement: "left",
    children: /* @__PURE__ */ a(Qt, {
      children: /* @__PURE__ */ a(n, {
        size: 16
      })
    })
  });
}
function Fn(e) {
  function n(o) {
    o.key === "Enter" && (o.preventDefault(), e.onSubmit());
  }
  return /* @__PURE__ */ a(en, {
    autoFocus: e.autofocus,
    size: "xs",
    value: e.value,
    onChange: (o) => e.onChange(o.currentTarget.value),
    onKeyDown: n,
    placeholder: e.placeholder
  });
}
function nt(e) {
  return /* @__PURE__ */ R(Ee, {
    children: [/* @__PURE__ */ a(On, {
      icon: e.icon,
      mainTooltip: e.mainIconTooltip,
      secondaryTooltip: e.secondaryIconTooltip
    }), /* @__PURE__ */ a(Fn, {
      autofocus: e.autofocus,
      placeholder: e.placeholder,
      value: e.value,
      onChange: e.onChange,
      onSubmit: e.onSubmit
    })]
  });
}
const gt = (e) => {
  const {
    classes: n
  } = N({
    root: {}
  })(void 0, {
    name: "EditHyperlinkMenu"
  }), [o, l] = M(e.url), [d, s] = M(e.text);
  return /* @__PURE__ */ R(Re, {
    className: n.root,
    children: [/* @__PURE__ */ a(nt, {
      icon: ut,
      mainIconTooltip: "Edit URL",
      autofocus: !0,
      placeholder: "Edit URL",
      value: o,
      onChange: (c) => l(c),
      onSubmit: () => e.update(o, d)
    }), /* @__PURE__ */ a(nt, {
      icon: ne,
      mainIconTooltip: "Edit Title",
      placeholder: "Edit Title",
      value: d,
      onChange: (c) => s(c),
      onSubmit: () => e.update(o, d)
    })]
  });
}, Bn = (e) => {
  const [n, o] = M(), [l, d] = M(!1), s = Te(null), c = A(() => {
    o(/* @__PURE__ */ a(gt, {
      url: e.activeHyperlinkUrl,
      text: e.activeHyperlinkText,
      update: (h, z) => {
        e.setHyperlink(h, z), d(!1);
      }
    }, Math.random() + ""));
  }, [e]), m = A((h) => {
    var z;
    if ((z = s.current) != null && z.contains(h.target)) {
      d(!l);
      return;
    }
    d(!1);
  }, [l]);
  return q(() => (document.body.addEventListener("click", m), () => document.body.removeEventListener("click", m)), [m]), /* @__PURE__ */ a(re, {
    appendTo: document.body,
    content: n,
    onShow: c,
    interactive: !0,
    maxWidth: 500,
    visible: l,
    children: /* @__PURE__ */ a(E, {
      isSelected: e.isSelected,
      mainTooltip: e.mainTooltip,
      secondaryTooltip: e.secondaryTooltip,
      icon: e.icon,
      ref: s
    })
  });
}, Ln = (e) => {
  const n = () => {
    const s = /* @__PURE__ */ new Set();
    return e.boldIsActive && s.add("bold"), e.italicIsActive && s.add("italic"), e.underlineIsActive && s.add("underline"), e.strikeIsActive && s.add("strike"), e.hyperlinkIsActive && s.add("link"), s;
  }, o = () => {
    if (e.block.type === "heading") {
      if (e.block.props.level === "1")
        return {
          text: "Heading 1",
          icon: me
        };
      if (e.block.props.level === "2")
        return {
          text: "Heading 2",
          icon: be
        };
      if (e.block.props.level === "3")
        return {
          text: "Heading 3",
          icon: pe
        };
    }
    return e.block.type === "bulletListItem" ? {
      text: "Bullet List",
      icon: xe
    } : e.block.type === "numberedListItem" ? {
      text: "Numbered List",
      icon: ye
    } : {
      text: "Paragraph",
      icon: ne
    };
  }, l = n(), d = o();
  return /* @__PURE__ */ R(vt, {
    children: [/* @__PURE__ */ a(_n, {
      text: d.text,
      icon: d.icon,
      items: [{
        onClick: () => e.updateBlock({
          type: "paragraph",
          props: {}
        }),
        text: "Paragraph",
        icon: ne,
        isSelected: e.block.type === "paragraph"
      }, {
        onClick: () => e.updateBlock({
          type: "heading",
          props: {
            level: "1"
          }
        }),
        text: "Heading 1",
        icon: me,
        isSelected: e.block.type === "heading" && e.block.props.level === "1"
      }, {
        onClick: () => e.updateBlock({
          type: "heading",
          props: {
            level: "2"
          }
        }),
        text: "Heading 2",
        icon: be,
        isSelected: e.block.type === "heading" && e.block.props.level === "2"
      }, {
        onClick: () => e.updateBlock({
          type: "heading",
          props: {
            level: "3"
          }
        }),
        text: "Heading 3",
        icon: pe,
        isSelected: e.block.type === "heading" && e.block.props.level === "3"
      }, {
        onClick: () => e.updateBlock({
          type: "bulletListItem",
          props: {}
        }),
        text: "Bullet List",
        icon: xe,
        isSelected: e.block.type === "bulletListItem"
      }, {
        onClick: () => e.updateBlock({
          type: "numberedListItem",
          props: {}
        }),
        text: "Numbered List",
        icon: ye,
        isSelected: e.block.type === "numberedListItem"
      }]
    }), /* @__PURE__ */ a(E, {
      onClick: e.toggleBold,
      isSelected: l.has("bold"),
      mainTooltip: "Bold",
      secondaryTooltip: w("Mod+B"),
      icon: gn
    }), /* @__PURE__ */ a(E, {
      onClick: e.toggleItalic,
      isSelected: l.has("italic"),
      mainTooltip: "Italic",
      secondaryTooltip: w("Mod+I"),
      icon: pn
    }), /* @__PURE__ */ a(E, {
      onClick: e.toggleUnderline,
      isSelected: l.has("underline"),
      mainTooltip: "Underline",
      secondaryTooltip: w("Mod+U"),
      icon: kn
    }), /* @__PURE__ */ a(E, {
      onClick: e.toggleStrike,
      isSelected: l.has("strike"),
      mainTooltip: "Strikethrough",
      secondaryTooltip: w("Mod+Shift+X"),
      icon: xn
    }), /* @__PURE__ */ a(E, {
      onClick: () => e.setTextAlignment("left"),
      isSelected: e.textAlignment === "left",
      mainTooltip: "Align Text Left",
      icon: vn
    }), /* @__PURE__ */ a(E, {
      onClick: () => e.setTextAlignment("center"),
      isSelected: e.textAlignment === "center",
      mainTooltip: "Align Text Center",
      icon: fn
    }), /* @__PURE__ */ a(E, {
      onClick: () => e.setTextAlignment("right"),
      isSelected: e.textAlignment === "right",
      mainTooltip: "Align Text Right",
      icon: hn
    }), /* @__PURE__ */ R(p, {
      children: [/* @__PURE__ */ a(p.Target, {
        children: /* @__PURE__ */ a(E, {
          mainTooltip: "Colors",
          icon: () => /* @__PURE__ */ a(ke, {
            textColor: e.textColor,
            backgroundColor: e.backgroundColor,
            size: 20
          })
        })
      }), /* @__PURE__ */ a(p.Dropdown, {
        children: /* @__PURE__ */ a(ft, {
          textColor: e.textColor,
          setTextColor: e.setTextColor,
          backgroundColor: e.backgroundColor,
          setBackgroundColor: e.setBackgroundColor
        })
      })]
    }), /* @__PURE__ */ a(E, {
      onClick: e.increaseBlockIndent,
      isDisabled: !e.canIncreaseBlockIndent,
      mainTooltip: "Indent",
      secondaryTooltip: w("Tab"),
      icon: bn
    }), /* @__PURE__ */ a(E, {
      onClick: e.decreaseBlockIndent,
      isDisabled: !e.canDecreaseBlockIndent,
      mainTooltip: "Decrease Indent",
      secondaryTooltip: w("Shift+Tab"),
      icon: mn
    }), /* @__PURE__ */ a(Bn, {
      isSelected: l.has("link"),
      mainTooltip: "Link",
      secondaryTooltip: w("Mod+K"),
      icon: ut,
      hyperlinkIsActive: e.hyperlinkIsActive,
      activeHyperlinkUrl: e.activeHyperlinkUrl,
      activeHyperlinkText: e.activeHyperlinkText,
      setHyperlink: e.setHyperlink
    })]
  });
}, Dn = (e) => ie(e, Ln, {
  animation: "fade",
  placement: "top-start"
}), An = (e) => {
  const [n, o] = M(!1);
  return n ? /* @__PURE__ */ a(gt, {
    url: e.url,
    text: e.text,
    update: e.editHyperlink
  }) : /* @__PURE__ */ R(vt, {
    children: [/* @__PURE__ */ a(E, {
      mainTooltip: "Edit",
      isSelected: !1,
      onClick: () => o(!0),
      children: "Edit Link"
    }), /* @__PURE__ */ a(E, {
      mainTooltip: "Open in new tab",
      isSelected: !1,
      onClick: () => {
        window.open(e.url, "_blank");
      },
      icon: Cn
    }), /* @__PURE__ */ a(E, {
      mainTooltip: "Remove link",
      isSelected: !1,
      onClick: e.deleteHyperlink,
      icon: yn
    })]
  });
}, Pn = (e) => ie(e, An, {
  animation: "fade",
  placement: "top-start"
}), Vn = 5;
function rt(e) {
  const n = Te(null), {
    classes: o
  } = N({
    root: {}
  })(void 0, {
    name: "SuggestionListItem"
  });
  function l() {
    var h;
    const c = e.isSelected, m = (h = n.current) == null ? void 0 : h.matches(":hover");
    return c || m;
  }
  function d() {
    var c, m;
    l() ? (c = n.current) == null || c.setAttribute("data-hovered", "true") : (m = n.current) == null || m.removeAttribute("data-hovered");
  }
  q(() => {
    d(), l() && n.current && n.current.getBoundingClientRect().left > Vn && n.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    });
  });
  let s;
  switch (e.name) {
    case "Heading":
      s = me;
      break;
    case "Heading 2":
      s = be;
      break;
    case "Heading 3":
      s = pe;
      break;
    case "Numbered List":
      s = ye;
      break;
    case "Bullet List":
      s = xe;
      break;
    case "Paragraph":
      s = ne;
      break;
  }
  return /* @__PURE__ */ a(p.Item, {
    className: o.root,
    icon: s && /* @__PURE__ */ a(s, {
      size: 18
    }),
    onClick: e.set,
    closeMenuOnClick: !1,
    onMouseLeave: () => {
      setTimeout(() => {
        d();
      }, 1);
    },
    ref: n,
    rightSection: e.shortcut && /* @__PURE__ */ a(tn, {
      size: "xs",
      children: e.shortcut
    }),
    children: /* @__PURE__ */ R(Re, {
      children: [/* @__PURE__ */ a(te, {
        size: 14,
        weight: 500,
        children: e.name
      }), /* @__PURE__ */ a(te, {
        size: 10,
        children: e.hint
      })]
    })
  });
}
const at = {
  Heading: "Used for a top-level heading",
  "Heading 2": "Used for key sections",
  "Heading 3": "Used for subsections and group headings",
  "Numbered List": "Used to display a numbered list",
  "Bullet List": "Used to display an unordered list",
  Paragraph: "Used for the body of your document"
}, it = {
  Heading: w("Mod-Alt-1"),
  "Heading 2": w("Mod-Alt-2"),
  "Heading 3": w("Mod-Alt-3"),
  "Numbered List": w("Mod-Alt-7"),
  "Bullet List": w("Mod-Alt-8"),
  Paragraph: w("Mod-Alt-0")
};
function jn(e) {
  const {
    classes: n
  } = N({
    root: {}
  })(void 0, {
    name: "SlashMenu"
  }), o = [], l = [];
  for (const c of e.items)
    c.name === "Heading" && o.push(c), c.name === "Heading 2" && o.push(c), c.name === "Heading 3" && o.push(c), c.name === "Numbered List" && l.push(c), c.name === "Bullet List" && l.push(c), c.name === "Paragraph" && l.push(c);
  const d = [];
  let s = 0;
  if (o.length > 0) {
    d.push(/* @__PURE__ */ a(p.Label, {
      children: "Headings"
    }, "Headings Label"));
    for (const c of o)
      d.push(/* @__PURE__ */ a(rt, {
        name: c.name,
        hint: at[c.name],
        shortcut: it[c.name],
        isSelected: e.keyboardHoveredItemIndex === s,
        set: () => e.itemCallback(c)
      }, c.name)), s++;
  }
  if (l.length > 0) {
    d.push(/* @__PURE__ */ a(p.Label, {
      children: "Basic Blocks"
    }, "Basic Blocks Label"));
    for (const c of l)
      d.push(/* @__PURE__ */ a(rt, {
        name: c.name,
        hint: at[c.name],
        shortcut: it[c.name],
        isSelected: e.keyboardHoveredItemIndex === s,
        set: () => e.itemCallback(c)
      }, c.name)), s++;
  }
  return /* @__PURE__ */ a(
    p,
    {
      defaultOpened: !0,
      trigger: "hover",
      closeDelay: 1e7,
      children: /* @__PURE__ */ a(p.Dropdown, {
        className: n.root,
        children: d.length > 0 ? d : /* @__PURE__ */ a(p.Item, {
          children: "No match found"
        })
      })
    }
  );
}
const Nn = (e) => ie(e, jn, {
  animation: "fade",
  placement: "bottom-start"
});
function Un() {
  const [, e] = M(0);
  return () => e((n) => n + 1);
}
const Zn = (e = {}, n = []) => {
  const [o, l] = M(null), d = Un();
  return q(() => {
    let s = !0, c = { ...e };
    c.uiFactories || (c = {
      ...c,
      uiFactories: {
        formattingToolbarFactory: Dn,
        hyperlinkToolbarFactory: Pn,
        slashMenuFactory: Nn,
        blockSideMenuFactory: Mn
      }
    }), console.log("create new blocknote instance");
    const m = new rn(c);
    return l(m), m.tiptapEditor.on("transaction", () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          s && d();
        });
      });
    }), () => {
      m.tiptapEditor.destroy(), s = !1;
    };
  }, n), o;
};
function $n() {
  const [, e] = M(0);
  return () => e((n) => n + 1);
}
const Qn = (e) => {
  const n = $n();
  q(() => {
    const o = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          n();
        });
      });
    };
    return e.on("transaction", o), () => {
      e.off("transaction", o);
    };
  }, [e]);
};
export {
  Xn as BlockNoteView,
  Mn as ReactBlockSideMenuFactory,
  Dn as ReactFormattingToolbarFactory,
  Pn as ReactHyperlinkToolbarFactory,
  Nn as ReactSlashMenuFactory,
  Zn as useBlockNote,
  Qn as useEditorForceUpdate
};
//# sourceMappingURL=blocknote-react.js.map
